import {combineReducers} from "redux";
import salesReport from "./salesReport/store/salesReportSlice";
import backInStockRequest from "./backInStockReport/store/backInReportSlice";
import exchangeOrder from "./exchangeOrder/store/exchangeOrderSlice"
import offerItemReport from "./verifyOfferItems/store/verifyOfferItemsSlice";
import invontoryReport from "./invontoryReport/store/invontoryReportSlice";
import orderItemReport from "./orderItemReport/store/orderItemReportSlice";
import handlingReport from "./handlingItem/store/handlingReportSlice";
import financesSummary from "./financesSummary/store/financesSummarySlice";
import vogaclosetReport from "./vogacloset/store/vogaclosetReportSlice";
import payoutReport from "./payout/store/payoutReportSlice";
import xeroInvoiceReport from "./xeroInvoice/store/xeroInvoiceReportSlice";
import citygoddessPurchaseReport from "./citygoddessPurchaseReport/store/citygoddessPurchaseReportSlice";
import purchaseInvoiceItemReport from "./citygoddessPurchaseReport/store/citygoddessPurchaseItemSlice";
import aiReport from "./aiReport/store/aiReportSlice";
import smartReport from "./smartReport/store/smartReportSlice";

const reportReducer = combineReducers({
    salesReport,
    backInStockRequest,
    exchangeOrder,
    offerItemReport,
    invontoryReport,
    orderItemReport,
    handlingReport,
    financesSummary,
    vogaclosetReport,
    payoutReport,
    xeroInvoiceReport,
    citygoddessPurchaseReport,
    purchaseInvoiceItemReport,
    aiReport,
    smartReport
});

export default reportReducer;